import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "@/components/AuthLayout";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé. Connectez-vous.");
      navigate("/connexion");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Nouveau mot de passe" subtitle="Choisissez un nouveau mot de passe sécurisé">
      {!token ? (
        <p className="text-[#FF4D4D]">Lien invalide. Veuillez refaire une demande.</p>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className="text-white mb-2 block">Nouveau mot de passe</Label>
            <Input
              type="password"
              data-testid="reset-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              className="bg-[#181820] border-white/10 text-white"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="reset-submit-btn"
            className="w-full gold-bg text-black font-semibold rounded-full py-6 hover:opacity-90"
          >
            {loading ? "Modification..." : "Réinitialiser"}
          </Button>
        </form>
      )}
      <Link to="/connexion" className="text-sm text-[#C9A24B] hover:underline block text-center mt-5">
        Retour à la connexion
      </Link>
    </AuthLayout>
  );
}
